export default "__VITE_ASSET__Cvz08jnN__"